import Breadcrumb from "./widget/Breadcrumb";
import EventsAllOne from "./widget/EventsAllOne";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";
import SEO from "./SEO";


const Activities = () => {
  return (
    <>
      <SEO
        title="National Public School Kudlu | Best CBSE School in Bengaluru"
        description="National Public School Kudlu offers quality CBSE education with experienced faculty, modern
infrastructure, sports, and holistic development."
        keywords="National Public School Kudlu,School Near Electronic City,School Near Bommanahalli,School Near Singasandra, NPS Kudlu,CBSE School Kudlu,Best CBSE School in Kudlu, Best CBSE School in Bengaluru, Top School in Kudlu, CBSE School Near Me, CBSE School Bangalore, Schools in Kudlu,
, Admissions Open CBSE School, Best School in Bangalore"
        canonical="https://npskudlu.com/"
      />
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Activities"} />

        {/* EventsAllOne */}
        <EventsAllOne />

        {/* FooterOne */}
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Activities;
